<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        @openEditFormDialog="openEditFormDialog"
        ref="header"
      >
      </page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
        v-if="editFormDialogOptions.visible"
        show-close
        visible
        width="800px"
        :title="editFormDialogOptions.title"
        :close-on-click-modal="false"
        :before-close="() => $refs.editForm.cancel()"
      >
        <edit-form
          ref="editForm"
          :disabled="editFormDialogOptions.disabled"
          :brandCode="editFormDialogOptions.code"
          @reload="reload"
          @close="closeEditFormDialog"
        />
        <span slot="footer">
          <el-button size="small" @click="$refs.editForm.cancel()">{{
            this.$l("INDEX.btn_cancel") || 取消
          }}</el-button>
          <el-button
            type="primary"
            size="small"
            v-if="!editFormDialogOptions.disabled"
            @click="$refs.editForm.save()"
            >{{ this.$l("INDEX.btn_save") || 保存 }}</el-button
          >
        </span>
      </el-dialog>
  </div>
</template>

<script>
import PageMain from "./main.vue";
import PageHeader from "./header.vue";
import EditForm from "../edit-form/index.vue";

const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0,
}

export default {
  components: {
    PageMain,
    PageHeader,
    EditForm,
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        ...initPage,
      },
      editFormDialogOptions: {
        visible: false,
        code: "",
      },
    };
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      };
      this.$nextTick(() => {
        this.$refs.header.query();
      });
    },
    // 重载表格数据
    reload() {
      this.$refs.header.query();
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true;
      this.$api
        .masterBrandListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false;
          this.page.pageTotal = res.body.count;
          this.table = res.body.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    reset() {
      this.page = {
        ...initPage,
      };
    },
    openEditFormDialog({ type, code = "" }) {
      const types = {
        edit: this.$l('form_label_brand_edit')||"编辑品牌信息",
        add: this.$l('form_label_brand_add')||"增加品牌信息",
        detail: this.$l('form_label_brand_detail')||"品牌信息详情",
      };
      // ********
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === "detail",
      };
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false;
    },
  },
};
</script>